import { Button } from '@chakra-ui/react'
import { ConfigurableChakraButton } from 'presentation/components/ConfigurableChakraComponents/ConfigurableChakraButton'

Button.defaultProps = {
  ...Button.defaultProps,
  spinnerPlacement: 'end',
}

ConfigurableChakraButton.defaultProps = Button.defaultProps
